//api-request.js
import { getUserData } from "../modules/auth/views/login/auth.api.js";


const API_BASE_URL = 'https://dashboard.pressuretrack.co.za/';

export const apiRequest = async (endpoint, options = {}) => {

  const { token } = getUserData() || {};
  const url = `${API_BASE_URL}${endpoint}`;
  const defaultHeaders = {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
    ...options.headers,
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
    credentials: 'include', // optional, only if your backend needs it
  };

  try {
    const response = await fetch(url, config); // Use Fetch API
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ message: 'Unknown error' }));
      throw new Error(
        `API request failed: ${response.status} - ${errorData.message || response.statusText
        }`
      );
    }
    // For passwordless endpoints, the response might not always be JSON,
    // so check content type or handle accordingly.
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return await response.json();
    } else {
      return response.text(); // Or handle as needed for non-JSON responses
    }
  } catch (error) {
    console.error('API Request Failed:', error);
    throw error; // Re-throw to be handled by calling component/state
  }
};
